import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

export const useInvalidateFilesQueries = () => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    const workspaceFilesQueryKey = `get:workspaces/objects`;
    const projectFilesQueryKey = `get:projects/files`;
    
    // Invalidate workspace files queries
    queryClient.invalidateQueries({
      queryKey: [workspaceFilesQueryKey],
    });
    
    // Invalidate project files queries
    queryClient.invalidateQueries({
      queryKey: [projectFilesQueryKey],
    });
  }, [queryClient]);
};